import React from 'react';

import Row from '@amzn/meridian/row';
import useProjectsFilters from '$/hooks/useProjectsFilters';
import { isNullOrWhitespace } from '@amzn/dots-core-ui';
import { useClient } from '$/api';
import { useHistory, useLocation } from 'react-router-dom';
import { CoreAsyncSelect } from '../CoreAsyncSelect';

export default function ProjectsFilterSection() {
  const { projects } = useClient();
  const history = useHistory();
  const { search } = useLocation();
  const projectsFilters = useProjectsFilters();

  const getTypes = async (query: string): Promise<string[]> => {
    if (isNullOrWhitespace(query)) {
      return [];
    }
    const { content } = await projects.getProjectNames(query);
    return content;
  };

  const onChangeFilter =
    (filter: string) => (value: string | string[] | undefined) => {
      if (!projectsFilters) {
        return;
      }
      if (!value) {
        projectsFilters.dispatch({ type: 'REMOVE_FILTER', filter });
      } else if (!Array.isArray(value)) {
        projectsFilters.dispatch({
          type: 'UPDATE_FILTER',
          filter,
          value,
        });
        const searchParams = new URLSearchParams(search);
        searchParams.set(filter, value);
        history.push({
          pathname: '/projects',
          search: `?${searchParams}`,
        });
      }
    };

  return (
    <Row spacing="400" widths="fill" wrap="down">
      <CoreAsyncSelect
        value={projectsFilters?.filters.get('name')}
        onChange={onChangeFilter('name')}
        label="Project"
        placeholder="Search projects..."
        getItems={getTypes}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
      <CoreAsyncSelect
        value={projectsFilters?.filters.get('product')}
        onChange={onChangeFilter('product')}
        label="Product"
        placeholder="Choose a product..."
        getItems={getTypes}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
      <CoreAsyncSelect
        value={projectsFilters?.filters.get('product family')}
        onChange={onChangeFilter('product family')}
        label="Product Family"
        placeholder="Choose a product family..."
        getItems={getTypes}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
    </Row>
  );
}
